import React, { useState, useEffect } from "react";
import Sync from "./../../../assets/icons/lsq_sync.svg";
import { CONSTANTS } from "../../../utils/constants";
import "./HardRefresh.css";
import { CACHE_TIME_MINUTES } from "../../../hooks/helpers";

export const HARD_REFRESH_MINUTES = 1;

const HardRefresh = ({ setForceRefresh, activeDashboardId, ...props }) => {
  const refreshCooldown = HARD_REFRESH_MINUTES * 60 * 1000;
  const cacheTimeInMilliseconds = CACHE_TIME_MINUTES * 60 * 1000;
  const [isDisabled, setIsDisabled] = useState(false);
  const [lastRefreshedTime, setLastRefreshedTime] = useState(null);
  const [isRotating, setIsRotating] = useState(false);
  const [timeAgo, setTimeAgo] = useState("");

  const formatTimeAgo = (date) => {
    const now = new Date();
    const lastUpdated = new Date(date);
    const diffInMs = now - lastUpdated;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    
    if (diffInMinutes < 1) {
      return "Just now";
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} min${diffInMinutes === 1 ? "" : "s"} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
    } else {
      return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
    }
  };

  useEffect(() => {
    const counterCache = JSON.parse(
      localStorage.getItem(CONSTANTS.countCacheName) || "{}"
    );
    const dashboardCache = counterCache[activeDashboardId] || {};
    const lastRefreshed = dashboardCache[CONSTANTS.lastForceRefreshedTime];

    if (lastRefreshed) {
      setLastRefreshedTime(lastRefreshed);
      const now = new Date().getTime();
      const timeSinceLastRefresh = now - new Date(lastRefreshed).getTime();
      if (timeSinceLastRefresh > cacheTimeInMilliseconds) {
        const newLastRefreshed = new Date().toISOString();
        dashboardCache[CONSTANTS.lastForceRefreshedTime] = newLastRefreshed;
        counterCache[activeDashboardId] = dashboardCache;
        localStorage.setItem(
          CONSTANTS.countCacheName,
          JSON.stringify(counterCache)
        );
        setLastRefreshedTime(newLastRefreshed);
      }
      if (timeSinceLastRefresh < refreshCooldown) {
        setIsDisabled(true);
        setTimeout(() => {
          setIsDisabled(false);
        }, refreshCooldown - timeSinceLastRefresh);
      }
    }
  }, [activeDashboardId]);

  // Update time ago every minute
  useEffect(() => {
    if (!lastRefreshedTime) return;

    const updateTimeAgo = () => {
      setTimeAgo(formatTimeAgo(lastRefreshedTime));
    };

    // Update immediately
    updateTimeAgo();

    // Update every minute
    const interval = setInterval(updateTimeAgo, 60000);

    return () => clearInterval(interval);
  }, [lastRefreshedTime]);

  const handleRefreshClick = () => {
    const now = new Date().toISOString();
    const counterCache = JSON.parse(
      localStorage.getItem(CONSTANTS.countCacheName) || "{}"
    );
    const dashboardCache = counterCache[activeDashboardId] || {};
    dashboardCache[CONSTANTS.lastForceRefreshedTime] = now;
    counterCache[activeDashboardId] = dashboardCache;
    localStorage.setItem(
      CONSTANTS.countCacheName,
      JSON.stringify(counterCache)
    );
    setForceRefresh((prev) => prev + 1);
    setIsDisabled(true);
    setLastRefreshedTime(now);
    setIsRotating(true);
    setTimeout(() => {
      setIsRotating(false);
    }, 1000);

    setTimeout(() => {
      setIsDisabled(false);
    }, refreshCooldown);
  };

  return (
    <div className="hard-refresh ng_p_2_r">
      <div className="last-updated">
        <span>Last Updated</span>
        <span>
          {lastRefreshedTime ? timeAgo : "Not available"}
        </span>
      </div>
      <button onClick={handleRefreshClick} disabled={isDisabled} {...props}>
        <img
          src={Sync}
          alt="Sync"
          className={isRotating ? "sync-rotate" : ""}
        />
      </button>
    </div>
  );
};

export default HardRefresh;
